import { render, staticRenderFns } from "./DetachIcon.vue?vue&type=template&id=b5d2ef1e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5d2ef1e')) {
      api.createRecord('b5d2ef1e', component.options)
    } else {
      api.reload('b5d2ef1e', component.options)
    }
    module.hot.accept("./DetachIcon.vue?vue&type=template&id=b5d2ef1e", function () {
      api.rerender('b5d2ef1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DetachIcon.vue"
export default component.exports